const Constant = {
    BASE_URL : window.location.hostname === 'localhost' ? 'http://localhost:8000/api/admin':  'https://www.api.megamultiservicio.com/api/admin'
}
export default Constant
